<template>
  <OnboardingModal
    ref="cashbackDetailsModal"
    data-cy="popup-cashback-transactions-modal"
    :title="$t('advancesPage.discountCreditTransactions')"
    align="left"
    :class="$style['cashback-details']"
    large
  >
    <MCAPaymentsCustomTable
      :data="transactions"
      :loading="fetchTransactionsRequest.isPending"
      class="dashboard-table-component"
      bordered
      manrope
    >
      <template #row="slotProps">
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          show="createdAt"
          :label="() => $t('advancesPage.date')"
          type="date"
          manrope
        />
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('advancesPage.description')"
          manrope
        >
          {{ formatDescription(slotProps?.row.description) }}
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          show="amountCents"
          :label="() => $t('advancesPage.amount')"
          type="money"
          manrope
        />
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          show="cashbackAmountCents"
          :label="() => $t('advancesPage.discountCredit')"
          type="money"
          manrope
        />
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('advancesPage.discountPercent')"
          manrope
        >
          {{
            $filters.percent(
              slotProps?.row.cashbackAmountCents / slotProps?.row.amountCents,
            )
          }}
        </MCAPaymentsCustomColumn>
      </template>
    </MCAPaymentsCustomTable>
  </OnboardingModal>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapRequestStatuses } from '@/utils/vuex-api-utils';

import MCAPaymentsCustomTable from '@/pages/mca/components/MCAPaymentsCustomTable.vue';
import MCAPaymentsCustomColumn from '@/pages/mca/components/MCAPaymentsCustomColumn.vue';
import OnboardingModal from '@/components/modals/OnboardingModal.vue';

export default {
  components: {
    OnboardingModal,
    MCAPaymentsCustomTable,
    MCAPaymentsCustomColumn,
  },
  computed: {
    ...mapGetters(['transactions', 'businessId']),
    ...mapRequestStatuses({
      fetchTransactionsRequest: 'FETCH_TRANSACTIONS',
    }),
  },
  methods: {
    /** @public */
    open(advanceId) {
      this.$store.dispatchApiAction('FETCH_TRANSACTIONS', {
        cashbackRepaysAdvanceId: advanceId,
        businessId: this.businessId,
      });
      this.$refs.cashbackDetailsModal.open();
    },
    formatDescription(description) {
      return description && description.replace('CB card - ', '');
    },
  },
};
</script>

<style lang="less" module>
.cashback-details {
  div[class^='title__'] {
    font-family: @manrope-font !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    margin-top: 32px !important;
  }
  div[class^='content__'] {
    padding: 30px !important;
  }
}
</style>
